export default "__VITE_ASSET__CyVGccvq__"